import { useContext, useMemo } from 'react';
import { UAParser } from 'ua-parser-js';
import { Context } from '@/context/UserAgent';

export function useMobileDetect() {
  const userAgent = useContext(Context);
  const isMobile = useMemo(() => {
    let parser: UAParser;
    if (typeof userAgent === 'undefined') {
      try {
        parser = new UAParser(navigator.userAgent);
      } catch {
        return false;
      }
    } else {
      parser = new UAParser(userAgent);
    }
    const device = parser.getDevice();
    return device.type === 'mobile' || device.type === 'tablet';
  }, [userAgent]);
  return isMobile;
}
